"use client";

import Loading from "@app/loading";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";

const BlogGrid1 = ({ item, currentPage }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const paragraphRef = useRef(null);
  const [text, setText] = useState("");

  const extractTextFromHtml = (html) => {
    if (html === undefined || html === null) {
      return null;
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    setText(doc.body.textContent);
  };

  const removeHeadingTags = (html) => {
    if (!html) return null;
    // Utiliser une expression régulière pour supprimer les balises <h1>, <h2>, etc.
    return html.replace(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/gi, "");
  };

  useEffect(() => {
    const cleanedHtml = removeHeadingTags(item.text);
    extractTextFromHtml(cleanedHtml);
    const checkTruncation = () => {
      const { scrollHeight, clientHeight } = paragraphRef.current;
      if (scrollHeight > clientHeight) {
        setIsTruncated(true);
      } else {
        setIsTruncated(false);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => {
      setText("");
      window.removeEventListener("resize", checkTruncation);
    };
  }, [text, item]);

  return (

    <>
      <div className="w-full mb-8 bg-primary-50/50 rounded-xl" style={{ position: "relative" }}>
        {isLoading && <Loading />}
        <Link
          href={`/${currentPage?.seo_permalink}/${item.seo_permalink ?? ''}`}
          onClick={() => setIsLoading(true)}>
          {item.images?.[0] ? (
            <img
              src={item.images[0].url ?? "/images/blog/2.jpg"}
              alt={item.images[0].alt ?? "Vieillir à la maison image article"}
              width={300}
              height={200}
              className="w-full rounded-tl-xl rounded-tr-xl"
            />
          ) : (
            <img
              width={300}
              height={200}
              className="w-full rounded-tl-xl rounded-tr-xl"
              src={`/images/blog/2.jpg`}
              alt="Image article vieillir à la maison"
            />
          )}
        </Link>
        <div className="py-8 px-5">
          <div className="mb-3 text-sm text-primary-400 tags-content wow animate__animated animate__fadeInUp">
            {item.categories?.map((categorie) => (
              <Link
                key={categorie.id}
                className="text-pgray-200 hover:underline"
                href={`/${currentPage?.seo_permalink}/sujet/${categorie?.slug}`}
                onClick={() => setIsLoading(true)}
              >
                <span className="inline-block py-1 px-3 text-xs font-semibold bg-primary-1000 text-primary-1000 rounded-xl mr-3 custom-tag-blog">
                  {categorie.title}
                </span>
              </Link>
            ))}
            {/*item.tags?.map((categorie) => (
              <Link
                key={categorie.id}
                className="text-pgray-200 hover:underline"
                href={`/${currentPage?.seo_permalink}/sujet/${categorie?.slug}`}
              >
                <span className="inline-block py-1 px-3 text-xs font-semibold bg-primary-100 text-primary-1000 rounded-xl mr-3">
                  {categorie.title}
                </span>
              </Link>
            ))*/}
          </div>
          <Link
            href={`/${currentPage?.seo_permalink}/${item.seo_permalink ?? ''}`}
            onClick={() => setIsLoading(true)}
          >
            <h3 className="my-2 text-xl font-semibold wow animate__animated animate__fadeInUp hover:text-primary-1000 transition duration-300">
              {item.title}
            </h3>
          </Link>

          <div className="content-pr">
            <p
              ref={paragraphRef}
              className="mt-4 mb-2 text-pgray-400 group-hover:text-pgray-500 transition duration-300 line-clamp-3"
            >
              {text}
            </p>
            {isTruncated && (
              <Link
                href={`/${currentPage?.seo_permalink}/${item.seo_permalink ?? ''}`}
                onClick={() => setIsLoading(true)}
                className="text-pgray-400 cursor-pointer group-hover:text-primary-1000"
              >
                <div style={{ textAlign: "right" }} >
                  <span className="hover:text-primary-1000 transition duration-300">
                    Lire la suite
                  </span>
                </div>
              </Link>
            )}
          </div>
        </div>

      </div>
    </>
  );
};

export default BlogGrid1;
